import { alpha } from '@mui/material';
import basicTheme from '../basicTheme.js';

const radioStyleOverrides = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            color: basicTheme.palette.primary.main,
            cursor: 'pointer',
            pointerEvents: 'auto',
            padding: '2px',
            '&:hover': {
                backgroundColor: alpha(basicTheme.palette.primary.main, 0.2),
            },
            '&.Mui-disabled': {
                opacity: '0.8',
                cursor: 'not-allowed',
                color: basicTheme.palette.N30.main,
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            },
        },
    },
};

export { radioStyleOverrides as default };
//# sourceMappingURL=MuiRadio.js.map
